import {useState} from 'react';
import React, { Component } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Multiselect from 'multiselect-react-dropdown';
import Container from "react-bootstrap/Container";
import Collapse from "react-bootstrap/Collapse";

import { validateCronExpression } from "../../../utils/UserTasksAPI"
import { copyReplaceAt } from '../../../utils/functions.js'
import { toggleBoxColumn } from '../../../utils/UIUtils.js'

export class UserTaskModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: this.props.show,
      error: false,
      tasks: [],
      tasksOpen: true
    }

    this.tasks = [];
    this.groups = [];

    if (props.local) {
      this.taskList = [
        //{label: 'Execute annotators', value:'DATASET_EXECUTE_ANNOTATORS'},
        {label: 'Execute all mappings', value:'DATASET_EXECUTE_MAPPINGS'},
        {label: 'Republish dataset', value:'DATASET_REPUBLISH'},
        {label: 'Recreate all indices', value:'DATASET_RECREATE_INDEXES'},
        {label: 'Recreate all distributions', value:'DATASET_RECREATE_DISTRIBUTIONS'} ]
    } else {
      this.taskList = [
        {label: 'Republish dataset', value:'DATASET_REPUBLISH'},
        {label: 'Recreate all indices', value:'DATASET_RECREATE_INDEXES'},
        {label: 'Recreate all distributions', value:'DATASET_RECREATE_DISTRIBUTIONS'} ]
    }

    this.complete(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();

    if (!this.state.validCronExpression) {
      return false;
    }

    if (!this.name.value) {
      return false;
    }

    var t = [];

    for (var i in this.state.tasks) {
      t.push({ 'type': this.state.tasks[i].type, 'group': parseInt(this.state.tasks[i].group) } );
    }

    if (t.length == 0) {
      return null;
    }

    this.props.onOK(this.props.userTask ? this.props.userTask.id : null, this.name.value, t, this.cronExpression.value, this.freshRunOnly? this.freshRunOnly.checked : false);
  }

  componentDidMount() {
    this.complete(this.props)
  }

  complete(props) {
    var tasks = props.userTask ? props.userTask.tasks : [];

    this.setState({ tasks: tasks,  validCronExpression: true }, () => {
      for (var i in tasks)  {
        this.tasks[i].value = tasks[i].type
        if (this.groups[i]) {
          this.groups[i].value = tasks[i].group
        }
      }
    })
  }

  addTask() {
    this.setState({ tasks: this.state.tasks.slice().concat({ type:'', group:-1 })},
      () => {
      for (var i in this.state.tasks)  {
        this.tasks[i].value = this.state.tasks[i].type
        if (this.groups[i]) {
          this.groups[i].value = this.state.tasks[i].group
        }
      }});
  }

  deleteTask(index) {
    this.setState({ tasks: this.state.tasks.slice(0, index).concat(this.state.tasks.slice(index + 1)) },
      () => {
      for (var i in this.state.tasks)  {
        this.tasks[i].value = this.state.tasks[i].type
        if (this.groups[i]) {
          this.groups[i].value = this.state.tasks[i].group
        }
      }})
  }

  // taskChanged(index, event) {
  //   this.setState(copyReplaceAt('tasks', this.state.tasks, index, { type: event.target.value}))
  // }

  taskChanged(index, type, value) {
    var obj = {...this.state.tasks[index], [type]: value}
    this.setState(copyReplaceAt('tasks', this.state.tasks, index, obj), () => { console.log( this.state.tasks)})
  }

  cronExpressionChanged(event) {
    validateCronExpression(event.target.value)
    .then(() => { this.setState( {validCronExpression : true } ) })
    .catch(() => { this.setState( {validCronExpression : false }) })
  }

  render() {

    return (
      <Modal show={this.props.show} onHide={this.props.onClose} animation={false} backdrop="static" size="m" >
        <Form onSubmit={this.handleSubmit}>
          <Modal.Header>
            <Modal.Title>User task</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label className="required">Name</Form.Label>
              <Form.Control ref={node => (this.name = node)}
                            defaultValue={this.props.userTask ? this.props.userTask.name : ""}/>
            </Form.Group>

{/*            <Row className="tableheader mb-3" />

            <Form.Group className="mb-0">
              <Form.Label className="bold">Tasks</Form.Label>
              <Button type="button" className="deleteaddbutton" aria-label="New" onClick={(event) => this.addTask()}><span className="fa fa-plus"></span></Button>
            </Form.Group> */}

            <Container className={this.state.tasks.length > 0 ? "groupborder" : "groupborder-empty"}>
              <Row className={this.state.tasks.length > 0 ? "header" : "header-empty"}>

                <Col className="bold">
                  {/*{this.props.dataset.name}: */}
                  <span className="crimson-std">Tasks</span>
                </Col>

                {toggleBoxColumn('tasksOpen', this, 'tasks')}

                <Col className="mybutton" md={1}>
                  <Button type="button" className="deleteaddbutton" aria-label="New" onClick={(event) => this.addTask()}><span className="fa fa-plus"></span></Button>
                </Col>
              </Row>

              <Collapse in={this.state.tasksOpen}>
                <div>
                  {this.state.tasks.map((el, index) =>
                  <Row key={index}>
                    <Col md="auto">
                      <span className="bold">{index + 1}</span>
                    </Col>
                    <Col>
                      <Form.Group>
                        <Form.Label className="required">Task</Form.Label>
                        <Row>
                          <Col md="7">
                            <Form.Control as="select"
                              ref={node => (this.tasks[index] = node)}
                              onChange={(event) => this.taskChanged(index, 'type', event.target.value)}
                              defaultValue={el} required>
                              <option disabled value=''> -- Select a task -- </option>
                              {this.taskList.map((el2, index2) =>
                                <option key={index2} value={el2.value}>{el2.label}</option>
                              )}
                            </Form.Control>
                          </Col>
                          {this.props.dataset.multiGroup &&
                          <Col md="5">
                            <Form.Control as="select"
                              ref={node => (this.groups[index] = node)}
                              onChange={(event) => this.taskChanged(index, 'group', event.target.value)}
                              defaultValue={el} required>
                              <option disabled value=''> -- Select a graph -- </option>
                              {Array.from({ length: this.props.dataset.maxGroup + 2 }, (value, index) => index).map((el2, index2) =>
                                <option key={index2} value={el2-1}>{el2-1 == -1 ? 'All' : el2-1}</option>
                              )}
                            </Form.Control>
                          </Col>
                          }
                          </Row>
                      </Form.Group>
                    </Col>

                    <Col md="auto">
                      <Button type="button" className="deleteeditbutton" aria-label="New" onClick={(event) => this.deleteTask(index)}><span className="fa fa-times"></span></Button>
                    </Col>
                  </Row>)}
                </div>
              </Collapse>
            </Container>

            <Form.Group>
              <Form.Label>Schedule</Form.Label>
              <Form.Control ref={node => (this.cronExpression = node)}
                            onChange={(event) => this.cronExpressionChanged(event)}
                            isInvalid={this.cronExpression && this.cronExpression.value && !this.state.validCronExpression}
                            defaultValue={this.props.userTask ? this.props.userTask.cronExpression : ""}/>
            </Form.Group>

            {!this.props.local &&
            <Form.Group>
              <Form.Check label="Run only if dataset has been updated" ref={node => (this.freshRunOnly = node)}
                defaultChecked={this.props.userTask ? this.props.userTask.freshRunOnly : false}/>
            </Form.Group>}


          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              OK
            </Button>
            <Button variant="secondary" onClick={this.props.onClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
  )}
}


export default UserTaskModal;
